import axios from "axios";

const transApi= process.env.REACT_APP_API_TRANSACTION;
const currentUser = JSON.parse(sessionStorage.getItem("authUser"));


export const createTransaction = async (data, business) => {
  try {
    const response = axios.post(`${transApi}/create`, data, {
      headers: {
        Authorization: `Bearer ${currentUser?.token}`,
        "x-api-key": business?.apiKey,
        "X-API-TOKEN": business?.apiToken,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPaymentMethods = async () => {
  try {
    const response =  axios.get(`${transApi}/payment-method/country`, {
      headers: {
        Authorization: `Bearer ${currentUser?.token}`,
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateTransaction = async (id, data) => {
  try {
    const response = await axios.put(`${transApi}/update/${id}`, data, {
      headers: {
        Authorization: `Bearer ${currentUser?.token}`,
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteTransaction = async (id) => {
  try {
    const response = await axios.delete(`${transApi}/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${currentUser?.token}`,
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCountryMethods = async () => {
  try {
    const response =  axios.get(`${transApi}/country/`, {
      headers: {
        Authorization: `Bearer ${currentUser?.token}`,
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTransactionByBusId = async (id) => {
  try {
    const response = await axios.get(`${transApi}/transfer/all/${id}`, {
      headers: {
        Authorization: `Bearer ${currentUser?.token}`,
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

  export const convertCurrency = async (totalTurnOver, fromCurrency,toCurrency ) => {
    try {
      const response = await axios.get(`${transApi}/transaction/convert?amount=${totalTurnOver}&fromCurrency=${fromCurrency}&toCurrency=${toCurrency}`, {
        headers: {
          Authorization: `Bearer ${currentUser?.token}`,
        }
      })
      return response;
    } catch (error) {
      throw error;
    }
  };
